import {
    ADMINGETLANGUAGEDROPLIST_SUCCESS,
    ADMINGETLANGUAGEDROPLIST_FAILED,
    RESET_ADMINGETLANGUAGEDROPLIST,
    LOADING_ADMINGETLANGUAGEDROPLIST,
    NETWORK_ERROR_ADMINGETLANGUAGEDROPLIST
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_ADMINGETLANGUAGEDROPLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case ADMINGETLANGUAGEDROPLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case ADMINGETLANGUAGEDROPLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_ADMINGETLANGUAGEDROPLIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_ADMINGETLANGUAGEDROPLIST:
            return (state = initialState);
        default:
            return state;
    }
};